// eslint-disable-next-line
/* eslint-disable */

import { api, apiTest } from './config'
import request from './request'

export default {
    visor: {
        retornarChamadas() {
            return request({
                url: '/painel/retornarChamadas/',
                method: 'get',
            })
        },
        retornarAnuncios() {
            return request({
                url: '/painel/retornarAnuncios',
                method: 'get',
            })
        },

        videoOffline(idVideo, nomeVideo, link) {
            var obj = {
                idVideo: idVideo,
                nomeVideo: nomeVideo,
                link: link
            }
            return request({
                url: '/painel/videoOffline/',
                method: 'post',
                data: obj
            })
        },

        retornarInfoPainel() {
            return request({
                url: '/painel/retornarInfoPainel/',
                method: 'get',
            })
        },
        refreshToken(token) {
            return request({
                url: '/painel/refreshToken',
                method: 'post',
                data: token
            })
        },

    },

}